import React from "react"
import QuestionPage from "../../templates/seo-collection/QuestionPage"

const Page = () => <QuestionPage destinationKey="holidayStays" questionKey="chaletServices" locale="fr" />

export default Page
